import { type FC } from 'react'

interface GooglePlayLogoProps {
	size?: string | number
}

export const GooglePlayLogo: FC<GooglePlayLogoProps> = ({ size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
		>
			{/* Left triangle - Blue */}
			<path 
				d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5" 
				fill="#4285F4"
			/>
			{/* Bottom triangle - Red */}
			<path 
				d="M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12" 
				fill="#EA4335"
			/>
			{/* Right triangle - Yellow */}
			<path 
				d="M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81" 
				fill="#FBBC04"
			/>
			{/* Top triangle - Green */}
			<path 
				d="M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" 
				fill="#34A853"
			/>
		</svg>
	)
}

export default GooglePlayLogo